import { types } from '../types/calc';

export const calcActions = Object.freeze({

  setStepOneData: (payload) => {
    return {
      type: types.SET_STEP_ONE_DATA,
      payload
    }
  },
  clearStepOneData: () => {
    return {
      type: types.CLEAR_STEP_ONE_DATA
    }
  },

  setStepTwoData: (payload) => {
    return {
      type: types.SET_STEP_TWO_DATA,
      payload
    }
  },

  clearStepTwoData: () => {
    return {
      type: types.CLEAR_STEP_TWO_DATA,
    }
  },

  clearAll: () => {
    return {
      type: types.CLEAR_ALL,
    }
  },

  showStepThree: (payload) => {
    return {
      type: types.SHOW_STEP_THREE,
      payload
    }
  },

});
